(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function addToCart(id, quantity) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: quantity || 1 }] })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || 'This item could not be added to your cart.');
        return data;
      });
    });
  }

  function refreshCartBubble() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    fetch(root + '?sections=cart-icon-bubble')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data['cart-icon-bubble'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('.shopify-section');
        bubble.innerHTML = inner ? inner.innerHTML : html;
        bubble.classList.remove('is-bump');
        void bubble.offsetWidth;
        bubble.classList.add('is-bump');
      })
      .catch(function () {});
  }

  var toastTimer;
  function toast(message, isError) {
    var el = document.querySelector('.aw-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'aw-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = '';
    var text = document.createElement('span');
    text.textContent = message;
    el.appendChild(text);
    if (!isError) {
      var link = document.createElement('a');
      link.href = root + 'cart';
      link.textContent = 'View cart';
      el.appendChild(link);
    }
    el.classList.toggle('is-error', !!isError);
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3400);
  }

  function formQuantity(form) {
    var input = form.querySelector('[name="quantity"]');
    return input ? Math.max(1, parseInt(input.value, 10) || 1) : 1;
  }

  // Add to cart (card quick-add and product page). Forms still post normally without JS.
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-aw-add]');
    if (!form) return;
    event.preventDefault();
    var button = form.querySelector('[type="submit"]');
    if (!button || button.disabled) return;
    var label = button.querySelector('[data-label]');
    var original = label ? label.textContent : '';
    button.disabled = true;
    form.classList.add('is-loading');

    addToCart(form.querySelector('[name="id"]').value, formQuantity(form))
      .then(function () {
        form.classList.remove('is-loading');
        form.classList.add('is-added');
        if (label) label.textContent = label.dataset.added || 'Added';
        refreshCartBubble();
        toast('Added to cart');
        setTimeout(function () {
          form.classList.remove('is-added');
          if (label) label.textContent = original;
          button.disabled = form.dataset.soldOut === 'true';
        }, 1700);
      })
      .catch(function (error) {
        form.classList.remove('is-loading');
        button.disabled = form.dataset.soldOut === 'true';
        toast(error.message, true);
      });
  });

  document.addEventListener('click', function (event) {
    // Buy it now: add, then go straight to checkout.
    var buyNow = event.target.closest('[data-aw-buy-now]');
    if (buyNow) {
      var buyForm = buyNow.closest('form[data-aw-add]');
      if (!buyForm || buyNow.disabled) return;
      buyNow.disabled = true;
      addToCart(buyForm.querySelector('[name="id"]').value, formQuantity(buyForm))
        .then(function () { window.location.href = root + 'checkout'; })
        .catch(function (error) { buyNow.disabled = false; toast(error.message, true); });
      return;
    }

    // Card colour swatches pick the variant the quick-add button will add.
    var swatch = event.target.closest('.aw-card .aw-swatch[data-variant-id]');
    if (swatch) {
      var card = swatch.closest('.aw-card');
      card.querySelectorAll('.aw-swatch').forEach(function (s) {
        var on = s === swatch;
        s.classList.toggle('is-selected', on);
        s.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var id = swatch.dataset.variantId;
      var input = card.querySelector('form[data-aw-add] [name="id"]');
      if (input) input.value = id;
      card.querySelectorAll('[data-product-url]').forEach(function (a) {
        a.href = a.dataset.productUrl + '?variant=' + id;
      });
      if (swatch.dataset.image) {
        var img = card.querySelector('.aw-card__img--a');
        if (img) { img.removeAttribute('srcset'); img.src = swatch.dataset.image; }
      }
      var cardForm = card.querySelector('form[data-aw-add]');
      var quick = card.querySelector('.aw-quick-add');
      var soldOut = swatch.dataset.available === 'false';
      if (cardForm) cardForm.dataset.soldOut = soldOut ? 'true' : '';
      if (quick) quick.disabled = soldOut;
    }
  });

  // Hero particle network: drifting dots joined by lines, pushed away from the cursor.
  function hexToRgb(hex) {
    var m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec((hex || '').trim());
    return m ? [parseInt(m[1], 16), parseInt(m[2], 16), parseInt(m[3], 16)] : [168, 64, 42];
  }

  function initParticles(canvas) {
    var hero = canvas.parentElement;
    var ctx = canvas.getContext('2d');
    if (!ctx) return;
    var rgb = hexToRgb(canvas.dataset.color).join(',');
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var LINK = 140;
    var REACH = 190;
    var w = 0;
    var h = 0;
    var points = [];
    var mouse = { x: null, y: null };
    var frame = null;
    var visible = true;

    function resize() {
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      w = hero.clientWidth;
      h = hero.clientHeight;
      canvas.width = Math.round(w * dpr);
      canvas.height = Math.round(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var count = Math.max(24, Math.min(110, Math.round((w * h) / 9000)));
      points = [];
      for (var i = 0; i < count; i++) {
        points.push({
          x: Math.random() * w,
          y: Math.random() * h,
          vx: (Math.random() - 0.5) * 0.6,
          vy: (Math.random() - 0.5) * 0.6
        });
      }
      draw();
    }

    function draw() {
      ctx.clearRect(0, 0, w, h);
      var i, j, p, q, dx, dy, d;
      for (i = 0; i < points.length; i++) {
        p = points[i];
        if (!still) {
          p.x += p.vx;
          p.y += p.vy;
          if (p.x < 0 || p.x > w) p.vx *= -1;
          if (p.y < 0 || p.y > h) p.vy *= -1;
        }
        if (mouse.x !== null) {
          dx = p.x - mouse.x;
          dy = p.y - mouse.y;
          d = Math.sqrt(dx * dx + dy * dy);
          if (d < REACH * 0.55 && d > 0) {
            p.x += (dx / d) * 1.6;
            p.y += (dy / d) * 1.6;
          }
        }
      }
      ctx.lineWidth = 1;
      for (i = 0; i < points.length; i++) {
        p = points[i];
        for (j = i + 1; j < points.length; j++) {
          q = points[j];
          dx = p.x - q.x;
          dy = p.y - q.y;
          d = dx * dx + dy * dy;
          if (d < LINK * LINK) {
            ctx.strokeStyle = 'rgba(' + rgb + ',' + (0.35 * (1 - Math.sqrt(d) / LINK)).toFixed(3) + ')';
            ctx.beginPath();
            ctx.moveTo(p.x, p.y);
            ctx.lineTo(q.x, q.y);
            ctx.stroke();
          }
        }
        if (mouse.x !== null) {
          dx = p.x - mouse.x;
          dy = p.y - mouse.y;
          d = Math.sqrt(dx * dx + dy * dy);
          if (d < REACH) {
            ctx.strokeStyle = 'rgba(' + rgb + ',' + (0.6 * (1 - d / REACH)).toFixed(3) + ')';
            ctx.beginPath();
            ctx.moveTo(p.x, p.y);
            ctx.lineTo(mouse.x, mouse.y);
            ctx.stroke();
          }
        }
        ctx.fillStyle = 'rgba(' + rgb + ',0.85)';
        ctx.beginPath();
        ctx.arc(p.x, p.y, 2.2, 0, Math.PI * 2);
        ctx.fill();
      }
    }

    function loop() {
      draw();
      frame = window.requestAnimationFrame(loop);
    }
    function start() {
      if (still || frame !== null || !visible || document.hidden) return;
      frame = window.requestAnimationFrame(loop);
    }
    function stop() {
      if (frame !== null) window.cancelAnimationFrame(frame);
      frame = null;
    }

    hero.addEventListener('pointermove', function (event) {
      var rect = hero.getBoundingClientRect();
      mouse.x = event.clientX - rect.left;
      mouse.y = event.clientY - rect.top;
      if (still) draw();
    });
    hero.addEventListener('pointerleave', function () {
      mouse.x = null;
      mouse.y = null;
      if (still) draw();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) start(); else stop();
      }).observe(hero);
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });
    if ('ResizeObserver' in window) {
      new ResizeObserver(resize).observe(hero);
    } else {
      window.addEventListener('resize', resize);
    }

    resize();
    start();
  }

  document.querySelectorAll('[data-aw-particles]').forEach(initParticles);

  // Mobile menu
  document.querySelectorAll('[data-aw-menu-toggle]').forEach(function (button) {
    var header = button.closest('.aw-header');
    button.addEventListener('click', function () {
      var open = header.classList.toggle('is-open');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  // Category pills
  document.querySelectorAll('[data-aw-filters]').forEach(function (bar) {
    var scope = bar.closest('[data-aw-shop]');
    bar.addEventListener('click', function (event) {
      var pill = event.target.closest('[data-filter]');
      if (!pill) return;
      bar.querySelectorAll('[data-filter]').forEach(function (p) {
        var on = p === pill;
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var filter = pill.dataset.filter;
      var shown = 0;
      scope.querySelectorAll('.aw-card').forEach(function (card) {
        var show = filter === 'all' || (' ' + card.dataset.types + ' ').indexOf(' ' + filter + ' ') > -1;
        card.hidden = !show;
        if (show) shown++;
      });
      var empty = scope.querySelector('[data-aw-empty-filter]');
      if (empty) empty.hidden = shown > 0;
    });
  });

  // Product page
  document.querySelectorAll('[data-aw-pdp]').forEach(function (pdp) {
    var dataEl = pdp.querySelector('[data-aw-product-json]');
    var data = dataEl ? JSON.parse(dataEl.textContent) : { variants: [] };
    var form = pdp.querySelector('form[data-aw-add]');
    var idInput = form && form.querySelector('[name="id"]');
    var priceEl = pdp.querySelector('[data-aw-price]');
    var button = form && form.querySelector('[type="submit"]');
    var buttonLabel = button && button.querySelector('[data-label]');
    var buyNow = pdp.querySelector('[data-aw-buy-now]');
    var slides = Array.prototype.slice.call(pdp.querySelectorAll('[data-aw-media]'));
    var thumbs = pdp.querySelectorAll('[data-aw-thumb]');

    function showMedia(id) {
      var target = slides.filter(function (s) { return s.dataset.awMedia === String(id); })[0];
      if (!target) return;
      slides.forEach(function (s) { s.classList.toggle('is-active', s === target); });
      thumbs.forEach(function (t) {
        var on = t.dataset.awThumb === String(id);
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }
    function step(direction) {
      if (!slides.length) return;
      var index = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
      var next = slides[(index + direction + slides.length) % slides.length];
      showMedia(next.dataset.awMedia);
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.dataset.awThumb); }); });
    var prev = pdp.querySelector('[data-aw-prev]');
    var next = pdp.querySelector('[data-aw-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    var groups = Array.prototype.slice.call(pdp.querySelectorAll('[data-aw-option]'));
    function selectedOptions() {
      return groups.map(function (g) {
        var s = g.querySelector('.is-selected');
        return s ? s.dataset.value : null;
      });
    }
    groups.forEach(function (group) {
      group.addEventListener('click', function (event) {
        var choice = event.target.closest('[data-value]');
        if (!choice) return;
        group.querySelectorAll('[data-value]').forEach(function (c) {
          var on = c === choice;
          c.classList.toggle('is-selected', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var label = group.querySelector('[data-aw-option-label]');
        if (label) label.textContent = choice.dataset.value;

        var options = selectedOptions();
        var variant = data.variants.filter(function (v) {
          return v.options.every(function (o, i) { return o === options[i]; });
        })[0];
        if (!variant) {
          if (button) { button.disabled = true; buttonLabel.textContent = buttonLabel.dataset.unavailable; }
          if (buyNow) buyNow.disabled = true;
          return;
        }
        idInput.value = variant.id;
        if (priceEl) priceEl.textContent = variant.price;
        form.dataset.soldOut = variant.available ? '' : 'true';
        if (button) {
          button.disabled = !variant.available;
          buttonLabel.textContent = variant.available ? buttonLabel.dataset.default : buttonLabel.dataset.soldout;
        }
        if (buyNow) buyNow.disabled = !variant.available;
        if (variant.media) showMedia(variant.media);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState(null, '', url.toString());
      });
    });

    var qty = pdp.querySelector('[name="quantity"]');
    pdp.querySelectorAll('[data-aw-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + Number(b.dataset.awQty));
      });
    });
  });
})();
